import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
let url = process.env.REACT_APP_API_URL;

const CreateOrder = () => {
  const navigate = useNavigate();

  const adminToken = localStorage.getItem("token");

  const [users, setUsers] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [addressDetails, setAddressDetails] = useState({});

  const [OrderStatus, setOrderStatus] = useState("Pending");
  const [reason, setReason] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("Unpaid");
  const [paymentId, setPaymentId] = useState("");
  const [paymentType, setPaymentType] = useState("COD");
  const [remarks, setRemarks] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [previewImageUrl, setPreviewImageUrl] = useState("");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const [searchUser, setSearchUser] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  const [searchProduct, setSearchProduct] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);

  const [cartProducts, setCartProducts] = useState([]);

  const [shippingCharge, setShippingCharge] = useState(0);
  const [couponPrice] = useState(0);

  const [originalPrice, setOriginalPrice] = useState(0);
  const [finalPrice, setFinalPrice] = useState(0);

  const [selectedProductId, setSelectedProductId] = useState(null);
  const [diamondRates, setDiamondRates] = useState([]);
  const [metalRates, setMetalRates] = useState([]);

  const updateAddressField = (field, value) => {
    setAddressDetails((prev) => ({
      ...(prev || {}),
      [field]: value,
    }));
  };

  const fetchDiamondRates = async () => {
    try {
      const res = await axios.get(`${url}/diamond`, {
        headers: {
          Authorization: adminToken,
        },
      });
      const data = Array.isArray(res.data) ? res.data : res.data.data;
      setDiamondRates(data);
    } catch (error) {
      console.error("Failed to fetch diamond rates", error);
      setDiamondRates([]);
    }
  };
  const fetchMetalPrices = async () => {
    try {
      const response = await axios.get(`${url}/metal`, {
        headers: {
          Authorization: adminToken,
        },
      });
      const metalsArray = response.data.data || response.data;
      setMetalRates(metalsArray);
    } catch (error) {
      console.error(error);
    }
  };
  const fetchShippingCharge = async () => {
    try {
      const response = await axios.get(`${url}/charges/get`, {
        headers: {
          Authorization: adminToken,
        },
      });

      const charges = response?.data?.Charges || {};
      setShippingCharge(Number(charges.Normal_Ship_Charge || 0));
    } catch (error) {
      setShippingCharge(0);
    }
  };

  useEffect(() => {
    fetchDiamondRates();
    fetchMetalPrices();
    fetchShippingCharge();
  }, []);

  // get users
  useEffect(() => {
    async function getUser() {
      setIsLoading(true);
      try {
        const res = await axios.get(`${url}/user/get/allreseller`, {
          headers: {
            Authorization: adminToken,
          },
        });
        setUsers(res?.data?.user || []);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    }

    getUser();
  }, [adminToken]);

  //get products
  async function getProducts() {
    try {
      setIsLoading(true);
      const res = await axios.get(`${url}/product/get`, {
        headers: {
          Authorization: adminToken,
        },
        params: {
          page: 1,
          limit: 100,
        },
      });

      setProductsData(res?.data?.product || []);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  async function getProduct() {
    try {
      setIsLoading(true);
      const res = await axios.get(`${url}/product/get/${selectedProductId}`, {
        headers: {
          Authorization: adminToken,
        },
      });

      console.log("single product data ==> ", res?.data?.products);
      setCartProducts((prev) => {
        const product = res?.data?.products;
        if (!product) return prev;

        const exists = prev.find((p) => p.product?._id === product._id);
        if (exists) {
          return prev.map((p) =>
            p.product?._id === product._id
              ? { ...p, quantity: Number(p.quantity || 1) + 1 }
              : p,
          );
        }

        return [
          ...prev,
          {
            product,
            variation: "",
            metalSizeId: "",
            diamondSizeId: "",
            quality: "",
            color: "",
            quantity: 1,
          },
        ];
      });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  }

  //get single product details
  useEffect(() => {
    if (selectedProductId) {
      getProduct();
    }
  }, [selectedProductId]);

  useEffect(() => {
    getProducts();
  }, []);

  // for create OrderStatus
  const createOrderStatus = [
    "Pending",
    "Accepted",
    "Pick Up",
    "Rejected",
    "Delivered",
    "Cancelled",
    "Returned",
  ];

  useEffect(() => {
    if (!searchUser) {
      setFilteredUsers([]);
      return;
    }

    const filtered = users.filter(
      (u) =>
        u.User_Name?.toLowerCase().includes(searchUser.toLowerCase()) ||
        u.User_Email?.toLowerCase().includes(searchUser.toLowerCase()),
    );

    setFilteredUsers(filtered);
  }, [searchUser, users]);

  useEffect(() => {
    if (!searchProduct) {
      setFilteredProducts([]);
      return;
    }

    const filtered = productsData.filter(
      (p) =>
        p.Product_Name?.toLowerCase().includes(searchProduct.toLowerCase()) ||
        p.SKU_Code?.toLowerCase().includes(searchProduct.toLowerCase()),
    );

    setFilteredProducts(filtered);
  }, [searchProduct, productsData]);

  const getMetalPrice = (metalComponents = [], metalCharges = {}) => {
    let totalMetal = 0;

    metalComponents.forEach((component) => {
      const metalMaster = (metalRates || []).find(
        (m) =>
          m.metalName?.toLowerCase() === component.metalType?.toLowerCase(),
      );

      if (!metalMaster) return;

      const numericPurity = Number(
        String(component.purity || "").replace(/k/i, ""),
      );
      const basePurity = Number(metalMaster.basePurity || 0);
      const baseRate = Number(metalMaster.baseRate || 0);
      const purityFactor = basePurity ? numericPurity / basePurity : 0;
      const ratePerGram = baseRate * purityFactor;
      const price = ratePerGram * Number(component.weight || 0);

      totalMetal += Number(price.toFixed(0));
    });

    totalMetal +=
      Number(metalCharges.labour || 0) + Number(metalCharges.making || 0);

    return Number(totalMetal.toFixed(2));
  };

  const normalizeQualityKey = (value) => {
    const raw = String(value || "").toLowerCase().trim();
    if (!raw) return "";

    const underscored = raw.replace(/[^a-z0-9]+/g, "_");
    if (
      underscored === "lab_vvs_vs" ||
      underscored === "natural_fg_vs" ||
      underscored === "natural_gh_si" ||
      underscored === "natural_hi_si" ||
      underscored === "single"
    ) {
      return underscored;
    }

    const spaced = raw.replace(/[^a-z0-9]+/g, " ").replace(/\s+/g, " ").trim();
    if (spaced === "lab vvs vs") return "lab_vvs_vs";
    if (spaced === "fg vs" || spaced === "natural fg vs") return "natural_fg_vs";
    if (spaced === "gh si" || spaced === "natural gh si") return "natural_gh_si";
    if (spaced === "hi si" || spaced === "natural hi si") return "natural_hi_si";

    return underscored;
  };

  const getDiamondPrice = (diamondSize, quality) => {
    if (!diamondSize) return 0;

    let diamondPrice = 0;

    (diamondSize.diamondComponents || []).forEach((component) => {
      const master = (diamondRates || []).find(
        (d) =>
          d.shape === component.shape &&
          Number(d.mm) === Number(component.mmSize),
      );

      if (!master) {
        const manual = Number(component.manualPrice || 0);
        if (!manual) return;
        diamondPrice += manual;
        return;
      }

      const normalizedSelectedQuality = normalizeQualityKey(quality);
      const qualityVariants = component.qualityVariants || [];
      const selectedQuality = qualityVariants.find(
        (q) =>
          normalizeQualityKey(q.quality) === normalizedSelectedQuality,
      );
      const singleQuality = qualityVariants.find((q) => {
        const key = normalizeQualityKey(q.quality);
        return key === "single" || key === "";
      });
      const resolvedQuality = selectedQuality || singleQuality || qualityVariants[0];

      const priceMode = master.priceMode || "quality";

      const ratePerCrt =
        priceMode === "single"
          ? Number(master.singlePrice || 0)
          : Number(master.qualityRates?.[resolvedQuality?.quality] || 0);
      const avgCaratPerStone = Number(master.caratWeight || 0);
      const totalCarat = avgCaratPerStone * Number(component.stones || 0);
      const mainDiamondPrice =
        priceMode === "single"
          ? Number(ratePerCrt.toFixed(2))
          : Number((ratePerCrt * totalCarat).toFixed(2));

      const otherTypesPrice = (resolvedQuality?.otherTypes || []).reduce(
        (sum, ot) => {
          return (
            sum +
            Number(ot.price || 0) +
            Number(ot.labour || 0) +
            Number(ot.making || 0)
          );
        },
        0,
      );

      diamondPrice += mainDiamondPrice + Number(otherTypesPrice.toFixed(2));
    });

    diamondPrice +=
      Number(diamondSize.diamondCharges?.labour || 0) +
      Number(diamondSize.diamondCharges?.making || 0);

    return Number(diamondPrice.toFixed(2));
  };

  const getItemPricing = (item) => {
    const variations = item.product?.Variation || [];
    const variation = variations.find((v) => v._id === item.variation);

    if (!variation) {
      return { unitPrice: 0, totalPrice: 0 };
    }

    const metalSize = variation.metalSizes?.find(
      (m) => m._id === item.metalSizeId,
    );

    if (!metalSize) {
      return { unitPrice: 0, totalPrice: 0 };
    }

    const metalPrice = getMetalPrice(
      metalSize.metalComponents || [],
      metalSize.metalCharges || {},
    );

    const diamondSize = metalSize.diamondSizes?.find(
      (d) => d._id === item.diamondSizeId,
    );

    const diamondPrice = getDiamondPrice(diamondSize, item.quality);

    const unitPrice = Number((metalPrice + diamondPrice).toFixed(2));
    const quantity = Number(item.quantity || 1);
    const totalPrice = Number((unitPrice * quantity).toFixed(2));

    return { unitPrice, totalPrice };
  };

  const formatMoney = (value) => Number(value || 0).toFixed(2);

  const getProductImageUrl = (image) => {
    if (!image) return "";
    const rawPath = typeof image === "string" ? image : image.path;
    if (!rawPath) return "";
    if (/^https?:\/\//i.test(rawPath)) return rawPath;
    const normalizedPath = String(rawPath).replace(/\\/g, "/");
    return `${url}/${normalizedPath}`;
  };

  const openImagePreview = (image) => {
    const imageUrl = getProductImageUrl(image);
    if (!imageUrl) return;
    setPreviewImageUrl(imageUrl);
    setIsPreviewOpen(true);
  };

  const closeImagePreview = () => {
    setIsPreviewOpen(false);
    setPreviewImageUrl("");
  };

  const handleCreateOrder = async () => {
    if (!selectedUser || cartProducts.length === 0) {
      alert("Select user and product");
      return;
    }

    const invalidItem = cartProducts.find((item) => {
      const variations = item.product?.Variation || [];
      const variation = variations.find((v) => v._id === item.variation);
      if (!variation) return true;

      const metalSize = variation.metalSizes?.find(
        (m) => m._id === item.metalSizeId,
      );
      if (!metalSize) return true;

      const diamondRequired =
        metalSize.diamondInvolved || (metalSize.diamondSizes || []).length > 0;

      if (diamondRequired && !item.diamondSizeId) return true;
      if (diamondRequired && !item.quality) {
        const diamondSize = metalSize.diamondSizes?.find(
          (d) => d._id === item.diamondSizeId,
        );
        const component = diamondSize?.diamondComponents?.[0];
        const master = (diamondRates || []).find(
          (d) =>
            d.shape === component?.shape &&
            Number(d.mm) === Number(component?.mmSize),
        );
        const priceMode = master?.priceMode || "quality";
        if (priceMode !== "single") return true;
      }

      return false;
    });

    if (invalidItem) {
      alert("Please select variation, size, and diamond details for all items");
      return;
    }

    const requiredAddressFields = [
      "Type",
      "House",
      "Full_Address",
      "City",
      "State",
      "Pincode",
      "Phone_Number",
    ];

    const missingAddress = requiredAddressFields.some(
      (field) => !addressDetails?.[field],
    );

    if (missingAddress) {
      alert("Please fill complete address details");
      return;
    }

    const addressId = addressDetails?._id || null;

    const payload = {
      userId: selectedUser._id,
      addressId,
      address: addressId ? undefined : addressDetails,
      cartData: cartProducts.map((p) => ({
        product: p.product._id,
        variation: p.variation,
        metalSizeId: p.metalSizeId,
        diamondSizeId: p.diamondSizeId,
        quality: p.quality,
        color: p.color,
        quantity: Number(p.quantity || 1),
      })),
      payment_mode: paymentType,
      payment_status: paymentStatus,
      PaymentId: paymentId,
      order_status: OrderStatus,
      remarks,
      reason,
    };

    try {
      setIsSaving(true);
      await axios.post(`${url}/order/admin/create-order`, payload, {
        headers: { Authorization: adminToken },
      });
      navigate("/showOrders");
    } catch (error) {
      alert("Failed to create order. Please check details and try again.");
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    const subtotal = cartProducts.reduce((sum, item) => {
      const pricing = getItemPricing(item);
      return sum + pricing.totalPrice;
    }, 0);

    setOriginalPrice(Number(subtotal.toFixed(2)));
  }, [cartProducts, diamondRates, metalRates]);

  useEffect(() => {
    const total =
      Number(originalPrice) + Number(shippingCharge) - Number(couponPrice);

    setFinalPrice(total > 0 ? total : 0);
  }, [originalPrice, shippingCharge, couponPrice]);

  return (
    <>
      <div className="main-content dark">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-2 table-heading">Create Orders</div>
              <div className="col-12 mt-2">
                <div className="card">
                  <div className="card-body">
                    {isLoading && (
                      <div className="d-flex justify-content-center py-3">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}

                    <form>
                      <div className="mt-2">
                        <label
                          htmlFor="example-text-input"
                          className="col-md-3"
                          style={{
                            color: "#AB8000",
                            textDecoration: "underline",
                          }}
                        >
                          User Details :
                        </label>

                        <div className="mb-3 row">
                          <label className="col-md-2 col-form-label">
                            Search User :-
                          </label>
                          <div className="col-md-10">
                            <input
                              className="form-control"
                              placeholder="Search by name / email / phone"
                              value={searchUser}
                              onChange={(e) => setSearchUser(e.target.value)}
                            />

                            {filteredUsers?.length > 0 && (
                              <ul
                                className="list-group position-absolute w-75"
                                style={{ zIndex: 999 }}
                              >
                                {filteredUsers?.map((u) => (
                                  <li
                                    key={u._id}
                                    className="list-group-item list-group-item-action"
                                    onClick={() => {
                                      setSelectedUser(u);
                                      setSearchUser("");
                                      setFilteredUsers([]);

                                      setAddressDetails({
                                        Phone_Number: u?.User_Mobile_No || "",
                                        Name: u?.User_Name || "",
                                      });
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {u.User_Name} ({u.User_Mobile_No})
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                          >
                            User Name :-
                          </label>
                          <div className="col-md-10 mt-1">
                            <input
                              type="text"
                              name="name"
                              id="name"
                              value={selectedUser?.User_Name}
                              className="form-control"
                            />
                          </div>
                          <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                          >
                            Mobile Number :-
                          </label>
                          <div className="col-md-10 mt-1">
                            <input
                              type="text"
                              name="phone"
                              id="phone"
                              value={selectedUser?.User_Mobile_No}
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="mt-2">
                        <label
                          htmlFor="example-text-input"
                          className="col-md-3"
                          style={{
                            color: "#AB8000",
                            textDecoration: "underline",
                          }}
                        >
                          Delivery Details :
                        </label>
                        <div className="mb-3 row">
                          <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                          >
                            Address Type (Home/Office):-
                          </label>
                          <div className="col-md-10 mt-1">
                            <input
                              type="text"
                              name="name"
                              id="name"
                              value={addressDetails?.Type || ""}
                              onChange={(e) =>
                                updateAddressField("Type", e.target.value)
                              }
                              className="form-control"
                              placeholder="Home or Office"
                            />
                          </div>
                          <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                          >
                            {addressDetails?.Type} no :-
                          </label>
                          <div className="col-md-10 mt-1">
                            <input
                              type="text"
                              name="name"
                              id="name"
                              value={addressDetails?.House || ""}
                              onChange={(e) =>
                                updateAddressField("House", e.target.value)
                              }
                              className="form-control"
                            />
                          </div>
                          <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                          >
                            Full Address:-
                          </label>
                          <div className="col-md-10 mt-1">
                            <textarea
                              type="text"
                              name="name"
                              id="name"
                              value={addressDetails?.Full_Address || ""}
                              onChange={(e) =>
                                updateAddressField(
                                  "Full_Address",
                                  e.target.value,
                                )
                              }
                              className="form-control"
                            />
                          </div>
                          <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                          >
                            City:-
                          </label>
                          <div className="col-md-4 mt-1">
                            <input
                              type="text"
                              name="name"
                              id="name"
                              value={addressDetails?.City || ""}
                              onChange={(e) =>
                                updateAddressField("City", e.target.value)
                              }
                              className="form-control"
                            />
                          </div>
                          <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                          >
                            State:-
                          </label>
                          <div className="col-md-4 mt-1">
                            <input
                              type="text"
                              name="name"
                              id="name"
                              value={addressDetails?.State || ""}
                              onChange={(e) =>
                                updateAddressField("State", e.target.value)
                              }
                              className="form-control"
                            />
                          </div>
                          <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                          >
                            Pincode:-
                          </label>
                          <div className="col-md-4 mt-1">
                            <input
                              type="text"
                              name="name"
                              id="name"
                              value={addressDetails?.Pincode || ""}
                              onChange={(e) =>
                                updateAddressField(
                                  "Pincode",
                                  e.target.value.replace(/\D/g, ""),
                                )
                              }
                              className="form-control"
                              inputMode="numeric"
                              pattern="[0-9]*"
                            />
                          </div>
                          <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                          >
                            Contact Number :-
                          </label>
                          <div className="col-md-4 mt-1">
                            <input
                              type="text"
                              name="phone"
                              id="phone"
                              value={addressDetails?.Phone_Number || ""}
                              onChange={(e) =>
                                updateAddressField(
                                  "Phone_Number",
                                  e.target.value,
                                )
                              }
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="form-group mt-3">
                        <label className="col-md-2 control-label">
                          Product details :-
                        </label>
                        <div className="col-md-12">
                          <div className="mb-3 row">
                            <label className="col-md-2 col-form-label">
                              Search Product :-
                            </label>
                            <div className="col-md-10">
                              <input
                                className="form-control"
                                placeholder="Search product / SKU"
                                value={searchProduct}
                                onChange={(e) =>
                                  setSearchProduct(e.target.value)
                                }
                              />

                              {filteredProducts.length > 0 && (
                                <ul className="list-group position-absolute w-75">
                                  {filteredProducts?.map((p) => (
                                    <li
                                      key={p._id}
                                      onClick={() => {
                                        setSelectedProductId(p._id);
                                        setSearchProduct("");
                                        setFilteredProducts([]);
                                      }}
                                      className="list-group-item cursor-pointer list-group-item-action"
                                    >
                                      <b>{p.Product_Name}</b> ({p.SKU_Code})
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          </div>

                          <table id="t01" style={{ width: "100%" }} border="1">
                            <thead>
                              <tr>
                                <th>Product</th>
                                <th>SKU Code</th>
                                <th>Image</th>
                                <th>Purity</th>
                                <th>Size</th>
                                <th>Select Diamond Size</th>
                                <th>Select Quality</th>
                                <th>Quantity</th>
                                <th>Total Price</th>
                                <th>Action</th>
                              </tr>
                            </thead>

                            <tbody>
                              {cartProducts?.map((item, index) => {
                                const variations =
                                  item.product?.Variation || [];

                                const selectedVariation =
                                  variations.find(
                                    (v) => v._id === item.variation,
                                  ) || null;

                                const metalSizes =
                                  selectedVariation?.metalSizes || [];

                                const selectedMetal =
                                  metalSizes.find(
                                    (m) => m._id === item.metalSizeId,
                                  ) || null;

                                const diamondSizes =
                                  selectedMetal?.diamondSizes || [];

                                const selectedDiamond =
                                  diamondSizes.find(
                                    (d) => d._id === item.diamondSizeId,
                                  ) || null;

                                const qualities =
                                  selectedDiamond?.diamondComponents?.[0]
                                    ?.qualityVariants || [];
                                const pricing = getItemPricing(item);

                                return (
                                  <tr key={index}>
                                    {/* PRODUCT */}
                                    <td>{item.product.Product_Name}</td>

                                    {/* SKU */}
                                    <td>{item.product.SKU_Code}</td>

                                    {/* IMAGE */}
                                    <td>
                                      <img
                                        src={getProductImageUrl(
                                          item.product?.Product_Images?.[0],
                                        )}
                                        style={{ width: 50, height: 50, cursor: "pointer" }}
                                        alt="Product"
                                        onClick={() =>
                                          openImagePreview(
                                            item.product?.Product_Images?.[0],
                                          )
                                        }
                                      />
                                    </td>

                                    {/* VARIATION / PURITY */}
                                    <td>
                                      <select
                                        value={item.variation || ""}
                                        onChange={(e) => {
                                          const value = e.target.value;

                                          setCartProducts((prev) =>
                                            prev.map((p, i) =>
                                              i === index
                                                ? {
                                                    ...p,
                                                    variation: value,
                                                    metalSizeId: "",
                                                    diamondSizeId: "",
                                                    quality: "",
                                                  }
                                                : p,
                                            ),
                                          );
                                        }}
                                      >
                                        <option value="">Select</option>

                                        {variations.map((v) => (
                                          <option key={v._id} value={v._id}>
                                            {v.variationName}
                                          </option>
                                        ))}
                                      </select>
                                    </td>

                                    {/* METAL SIZE */}
                                    <td>
                                      <select
                                        value={item.metalSizeId || ""}
                                        onChange={(e) => {
                                          setCartProducts((prev) =>
                                            prev.map((p, i) =>
                                              i === index
                                                ? {
                                                    ...p,
                                                    metalSizeId: e.target.value,
                                                    diamondSizeId: "",
                                                    quality: "",
                                                  }
                                                : p,
                                            ),
                                          );
                                        }}
                                      >
                                        <option value="">Select</option>

                                        {metalSizes.map((size) => (
                                          <option
                                            key={size._id}
                                            value={size._id}
                                          >
                                            {size.sizeLabel}
                                          </option>
                                        ))}
                                      </select>
                                    </td>

                                    {/* DIAMOND SIZE */}
                                    <td>
                                      <select
                                        value={item.diamondSizeId || ""}
                                        onChange={(e) => {
                                          setCartProducts((prev) =>
                                            prev.map((p, i) =>
                                              i === index
                                                ? {
                                                    ...p,
                                                    diamondSizeId:
                                                      e.target.value,
                                                    quality: "",
                                                  }
                                                : p,
                                            ),
                                          );
                                        }}
                                      >
                                        <option value="">Select</option>

                                        {diamondSizes.map((d) => (
                                          <option key={d._id} value={d._id}>
                                            {d.sizeLabel}
                                          </option>
                                        ))}
                                      </select>
                                    </td>

                                    {/* QUALITY */}
                                    <td>
                                      <select
                                        value={item.quality || ""}
                                        onChange={(e) => {
                                          setCartProducts((prev) =>
                                            prev.map((p, i) =>
                                              i === index
                                                ? {
                                                    ...p,
                                                    quality: e.target.value,
                                                  }
                                                : p,
                                            ),
                                          );
                                        }}
                                      >
                                        <option value="">Select</option>

                                        {qualities.map((q) => (
                                          <option key={q._id} value={q.quality}>
                                            {q.quality}
                                          </option>
                                        ))}
                                      </select>
                                    </td>

                                    {/* QUANTITY */}
                                    <td>
                                      <input
                                        type="number"
                                        min={1}
                                        className="form-control"
                                        style={{ width: "80px" }}
                                        value={item.quantity || 1}
                                        onChange={(e) => {
                                          const qty = Number(e.target.value);

                                          setCartProducts((prev) =>
                                            prev.map((p, i) =>
                                              i === index
                                                ? {
                                                    ...p,
                                                    quantity: qty > 0 ? qty : 1,
                                                  }
                                                : p,
                                            ),
                                          );
                                        }}
                                      />
                                    </td>

                                    {/* TOTAL PRICE (Preview only) */}
                                    <td>
                                      £{" "}
                                      {formatMoney(pricing.totalPrice)}
                                    </td>

                                    {/* REMOVE */}
                                    <td>
                            <button
                                        type="button"
                                        className="btn btn-danger btn-sm"
                                        onClick={() => {
                                          setCartProducts((prev) =>
                                            prev.filter((_, i) => i !== index),
                                          );
                                        }}
                                      >
                                        Remove
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="form-group mt-3">
                        <label className="col-md-2 control-label">
                          Amount Details :-
                        </label>
                        <div className="col-md-12 orderDetailsTable">
                          <table id="t01" style={{ width: "100%" }} border="1">
                            <tr>
                              <th>Total Amount</th>
                              <th>Shipping Charges</th>

                              <th>Final Amount</th>

                              <th>Payment Status</th>
                            </tr>
                            <tr>
                              <td>
                                <b>£ {formatMoney(originalPrice)}/-</b>
                              </td>
                              <td>
                                <b> + £ {formatMoney(shippingCharge)}/-</b>
                              </td>

                              <td>
                                <b>£ {formatMoney(finalPrice)}/-</b>
                              </td>

                              <td>
                                <b>Payment Status : {paymentStatus}</b>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                      <br />

                      <div className="mt-2">
                        <label
                          className="col-md-3"
                          style={{
                            color: "#AB8000",
                            textDecoration: "underline",
                          }}
                        >
                          Payment Details :
                        </label>

                        <div className="mb-3 row">
                          {/* Payment Mode */}
                          <label className="col-md-2 col-form-label">
                            Payment Type :-
                          </label>
                          <div className="col-md-10 mt-1">
                            <select
                              className="form-control"
                              value={paymentType}
                              onChange={(e) => setPaymentType(e.target.value)}
                            >
                              <option value="COD">COD</option>
                              <option value="ONLINE">Online</option>
                              <option value="BANK">Bank Transfer</option>
                            </select>
                          </div>

                          {/* Payment Status */}
                          <label className="col-md-2 col-form-label">
                            Payment Status :-
                          </label>
                          <div className="col-md-10 mt-1">
                            <select
                              className="form-control"
                              value={paymentStatus}
                              onChange={(e) => setPaymentStatus(e.target.value)}
                            >
                              <option value="Unpaid">Unpaid</option>
                              <option value="Paid">Paid</option>
                              <option value="Failed">Failed</option>
                            </select>
                          </div>

                          {/* Payment ID */}
                          <label className="col-md-2 col-form-label">
                            Payment ID :-
                          </label>
                          <div className="col-md-10 mt-1">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Transaction ID / Ref No"
                              value={paymentId}
                              onChange={(e) => setPaymentId(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="mt-2">
                        <label
                          htmlFor="example-text-input"
                          className="col-md-3"
                          style={{
                            color: "#AB8000",
                            textDecoration: "underline",
                          }}
                        >
                          Order Status :
                        </label>

                        <div className="mb-3 row">
                          <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                          >
                            Order Status :-
                          </label>
                          <div className="col-md-10 mt-1">
                            <select
                              name="o_type"
                              id="o_type"
                              style={{ width: "30%", height: "100%" }}
                              className="select2"
                              value={OrderStatus}
                              onChange={(e) => setOrderStatus(e.target.value)}
                              required
                            >
                              <option value="">Select Status</option>
                              {createOrderStatus?.map((status) => (
                                <option key={status} value={status}>
                                  {status}
                                </option>
                              ))}
                            </select>
                          </div>

                          <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                          >
                            Reason :-
                          </label>
                          <div className="col-md-10 mt-1">
                            <input
                              type="text"
                              name="name"
                              id="name"
                              value={reason}
                              onChange={(e) => setReason(e.target.value)}
                              className="form-control"
                            />
                          </div>
                          <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                          >
                            Remarks :-
                          </label>
                          <div className="col-md-10 mt-1">
                            <input
                              type="text"
                              name="remarks"
                              id="remarks"
                              value={remarks}
                              onChange={(e) => setRemarks(e.target.value)}
                              className="form-control"
                              placeholder="Created by admin (optional)"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row mb-10">
                        <div className="col ms-auto">
                          <div className="d-flex flex-reverse flex-wrap gap-2">
                            <a
                              className="btn btn-danger"
                              onClick={() => navigate("/showOrders")}
                            >
                              {" "}
                              <i className="fas fa-window-close"></i>{" "}
                              Cancel{" "}
                            </a>
                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={handleCreateOrder}
                              disabled={isSaving}
                            >
                              {isSaving && (
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              )}
                              <i className="fas fa-save"></i>{" "}
                              {isSaving ? "Creating..." : "Save"}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isPreviewOpen && (
        <div
          onClick={closeImagePreview}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.7)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
          }}
        >
          <img
            src={previewImageUrl}
            alt="Preview"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "90vw",
              maxHeight: "90vh",
              borderRadius: 8,
              background: "#fff",
            }}
          />
        </div>
      )}
    </>
  );
};

export default CreateOrder;








